import { useTranslation } from 'react-i18next';

function TablePagination({ page, totalPages, onChange }) {
  const { t } = useTranslation('common');
  if (totalPages <= 1) return null;

  return (
    <div className="pagination-controls">
      <button type="button" className="text-btn" disabled={page === 1} onClick={() => onChange(Math.max(1, page - 1))}>{t('pagination.prev')}</button>
      <span className="pagination-status">{t('pagination.page', { current: page, total: totalPages })}</span>
      <button type="button" className="text-btn" disabled={page === totalPages} onClick={() => onChange(Math.min(totalPages, page + 1))}>{t('pagination.next')}</button>
    </div>
  );
}

export default TablePagination;
